import { createSelector } from 'reselect'
import get from 'lodash/get'
import { getFormValues as getGetFormValuesStore } from 'redux-form'
import getPropSelector from 'loankeeper-common/helpers/getPropSelector'

const getState = (state) => state

const getGetFormValues = createSelector(getPropSelector('formMeta.form'), (formName) => getGetFormValuesStore(formName))

export const makeGetCheckboxDisabled = () =>
  createSelector(
    getPropSelector('disCbFldProps.name'),
    getGetFormValues,
    getState,
    (disCbFldName, getFormValues, state) => get(getFormValues(state), disCbFldName),
  )
